module.exports = __webpack_public_path__ + "img/plugin-workspace.d3c29e3c.webp";